var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import SyntaxHighlighter, { registerLanguage } from 'react-syntax-highlighter/dist/light';
import js from 'highlight.js/lib/languages/javascript';
registerLanguage('javascript', js);
const PreTag = ({ children }) => React.createElement("pre", { className: "highlight-block" }, children);
const CodeTag = ({ children }) => React.createElement("code", { className: "hljs javascript" }, children);
const CodeBlock = (_a) => {
    var { code } = _a, props = __rest(_a, ["code"]);
    return (React.createElement(SyntaxHighlighter, Object.assign({ language: "javascript", useInlineStyles: false, PreTag: PreTag, CodeTag: CodeTag }, props), code));
};
CodeBlock.propTypes = {
    code: PropTypes.string,
};
PreTag.propTypes = {
    children: PropTypes.node,
};
CodeTag.propTypes = {
    children: PropTypes.node,
};
export default CodeBlock;
